module.exports = __webpack_public_path__ + "static/construccion-325ac240b713e4a7c6c3433e4e6aa33a.jpg";